import EmberObject from '@ember/object';
import { isEmpty } from '@ember/utils';
import { sortBy } from '@linc-technologies/linced-common/utils/arrays';
import { TrackedArray } from 'tracked-built-ins';
import moment from 'moment';

// buildChipDataMap builds a map in the form:
// [teacherIdKey][date][] = {allocation,bookings,slot}
export function buildChipDataMap(allocations, slots, allBookings) {
  if (isEmpty(allocations)) {
    return;
  }
  let chipData = allocations.reduce((chipData, allocation) => {
    let key = teacherIdKey(allocation.get('teacher_ids'));
    let slot = slots.find((s) => s.id === allocation.get('slot_id'));
    // TrackedArray, not a plain array: booking-chip.js mutates this in
    // place (push/splice) as bookings are created/cancelled, and needs
    // that to be independently reactive.
    let bookings = new TrackedArray(
      allBookings.filter(
        (booking) => booking.allocation_id === allocation.get('id'),
      ),
    );
    let date = slot.get('date');
    let chipDataObject = EmberObject.create({
      allocation,
      bookings,
      slot,
    });
    if (isEmpty(chipData[key])) {
      chipData[key] = EmberObject.create({});
    }
    if (isEmpty(chipData[key][date])) {
      chipData[key][date] = [chipDataObject];
    } else {
      chipData[key][date].push(chipDataObject);
    }
    return chipData;
  }, EmberObject.create({}));
  Object.entries(chipData).forEach(([teacherIdKey, dates]) => {
    Object.entries(dates).forEach(([date, chips]) => {
      chipData[teacherIdKey][date] = sortBy(chips, 'slot.time');
    });
  });
  return chipData;
}

export function teacherIdKey(teacherIdArray) {
  return teacherIdArray.sort().join('-');
}

export function bookingTable(data, event) {
  let content = '';
  Object.entries(data).forEach(([date, dataSet]) => {
    let dateHasBookings = dataSet.some((data) => {
      return !isEmpty(data.bookings);
    });
    if (!dateHasBookings) {
      return;
    }
    content += `<h3>${moment(date, 'YYYY-MM-DD').format(
      'Do MMMM YYYY (dddd)',
    )}</h3>`;
    content += `<table>
              <tr>
                <th>Time</th>
                <th>Student</th>
                <th>Caregiver</th>
                <th>Caregiver Note</th>
                <th>Staff Note</th>
              </tr>`;
    let breakStartTime = 0;
    let firstBookingDone = false;
    let newAllocation = false;
    dataSet.forEach((data, index) => {
      newAllocation = true;
      let startTime = moment.unix(data.slot.time);
      let endTime = moment(startTime).add(event.get('slotLength'), 'minutes');
      if (!isEmpty(data.bookings)) {
        if (breakStartTime !== 0 && firstBookingDone) {
          content += `  <tr>`;
          content += `    <td colspan="5">&nbsp;</td>`;
          content += `  </tr>`;
        }
        data.bookings.forEach((booking) => {
          content += `  <tr>`;
          content += `    <td>`;
          if (newAllocation) {
            content += `      ${startTime.format('h:mma')} - ${endTime.format(
              'h:mma',
            )}`;
          }
          content += `    </td>`;
          newAllocation = false;
          content += `    <td>${booking.get('student.fullName')}</td>`;
          content += `    <td>${booking.get('caregiver.fullName')}</td>`;
          content += `    <td>${booking.get('caregiverNote') ?? ''}</td>`;
          content += `    <td>${booking.get('staffNote') ?? ''}</td>`;
          content += `  </tr>`;
        });
        firstBookingDone = true;
        breakStartTime = 0;
        if (event.sessionBreakIndexesByDate[date].includes(index)) {
          breakStartTime = endTime.unix();
        }
      } else if (breakStartTime === 0) {
        breakStartTime = data.slot.time;
      }
    });

    content += `</table>`;
  });
  return content;
}
